import { ApolloQueryResult } from 'apollo-client';

import {
    pricePackagesQuery,
    pricePackagesQueryForEdit,
    pricePackagesSuggest
} from '../../graphql/queries/grid/pricePackages';
import {
    mapPricePackagesQueryResultToEntitiesQueryResponse,
    mapPricePackagesSuggestQueryResultToSuggestQueryResponse,
    mapSourceParamsToPricePackagesAndSuggestQueryVariables
} from '../../mappers/pricePackages/pricePackages';
import { PricePackagesQuery, PricePackagesQueryForEdit, PricePackagesSuggestQuery } from '../../typings/graphql-grid';
import {
    PricePackageEditData,
    PricePackageId,
    PricePackagesData,
    PricePackagesSourceParams
} from '../../typings/pricePackages';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export interface PricePackagesQueryResponse {
    data: PricePackagesData;
    reqId: string;
}

export interface PricePackagesEditQueryResponse {
    data: Record<PricePackageId, PricePackageEditData>;
    reqId: string;
}

export class PricePackagesDataProvider extends BaseDataProvider {
    public fetchPricePackagesGridDataSegment = (
        params: PricePackagesSourceParams,
        offset: number,
        count: number
    ): Promise<PricePackagesQueryResponse> => {
        const query = this.createQuery<PricePackagesQuery>(pricePackagesQuery, {
            variables: {
                input: {
                    ...mapSourceParamsToPricePackagesAndSuggestQueryVariables(params),
                    limitOffset: {
                        offset,
                        limit: count
                    }
                }
            }
        });

        return query.then((result: ApolloQueryResult<PricePackagesQuery>) =>
            mapPricePackagesQueryResultToEntitiesQueryResponse(result)
        );
    };

    public fetchPricePackagesSuggestData = (params: PricePackagesSourceParams) => {
        const query = this.createQuery<PricePackagesSuggestQuery>(pricePackagesSuggest, {
            variables: {
                input: {
                    limitOffset: {
                        offset: 0,
                        limit: 10000
                    },
                    ...mapSourceParamsToPricePackagesAndSuggestQueryVariables(params)
                }
            }
        });

        return query.then((result: ApolloQueryResult<PricePackagesSuggestQuery>) =>
            mapPricePackagesSuggestQueryResultToSuggestQueryResponse(result)
        );
    };

    public fetchPricePackagesDataForEdit = (pricePackagesIds: PricePackageId[]) => {
        return this.createQuery<PricePackagesQueryForEdit>(pricePackagesQueryForEdit, {
            variables: {
                input: {
                    limitOffset: {
                        offset: 0,
                        limit: 100
                    },
                    filter: {
                        packageIdIn: pricePackagesIds
                    }
                }
            }
        });
    };
}
